module.exports = __webpack_public_path__ + "static/media/301.201bde6f.wav";